import { render, staticRenderFns } from "./MetricHistoryTable.vue?vue&type=template&id=03c25d10&scoped=true&"
import script from "./MetricHistoryTable.vue?vue&type=script&lang=js&"
export * from "./MetricHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./MetricHistoryTable.vue?vue&type=style&index=0&id=03c25d10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c25d10",
  null
  
)

export default component.exports